import { TeamsDetailsPage } from 'components/settings/teams/components/teamsDetailsPage';

export const SettingsTeamsEditView = TeamsDetailsPage;
